import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import moment from "moment";
import utils from '../../../utils/generalFunctions';
import academicService from "../../../services/academicService";
import { toast } from 'react-toastify';
import Loading from "../../../components/Loading";
import JornadaAnioPeriodoNivelCurso from "../../../components/Filters/JornadaAnioPeriodoNivelCurso";
import estudiantesService from "../../../services/estudiantesService";
import DataTable from "react-data-table-component";
import useCustomDataTableStyles from "../../../components/estilosDeDataTable";
import evaluativeScaleService from "../../../services/evaluativeScaleService";
import RepoBoletin from "./boletin";

const RepoBoletinFinal = () => {
    const filteReference = useRef(null);
    const initData ={
        schoolYearId: "0",
        journeyId:"0",
        periodId:"",
        educationLevelId: "0",
    };
    const [formData, setFormData] = useState(initData);
    const [datosBusqueda, setDatosBusqueda] = useState([]);
    const [periodos, setPeriodosList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [estudiantes, setEstudiantes] = useState([]);        
    const [filterText, setFilterText] = useState('');
    const [boletinInfo, setBoletinInfo] = useState(null);
    
    const updateForm = async (data) => {
        if (data.schoolYearId!==formData.schoolYearId){   
          await cargarPeriodos(data.schoolYearId);
        }
        setFormData(prevState => ({
            ...prevState,
            ...data
          }));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const cargarPeriodos = async (schoolYearId) => {
        try {
            const schoolYear = await academicService.getYearById(schoolYearId);              
            if(schoolYear){
                setPeriodosList(schoolYear.periods)
            }            
        } catch (error) {
             console.error("Error al obtener información de año escolar:", error);
        }
      }

    const generarCosolidadReporteTotal = async () =>{
      setBoletinInfo(null);
        const requiredFields = ['schoolYearId', 'journeyId', 'periodId','educationLevelId','courseId'];
        for (let field of requiredFields) {
            if (!formData[field] || formData[field]==='0') {
                toast.error("Por favor, completa todos los campos obligatorios.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                return;
            }
        }
        setDatosBusqueda([]);
        setShowLoading(true);
        try {
           const copyData = utils.copy(formData);
           copyData.periodName = periodos.find(p=>String(p.academicPeriodId)===String(copyData.periodId))?.periodName??"";
           const years = filteReference.current?.getSchoolYears();
           if(years){
                copyData.year = years.find(p=>String(p.schoolYearId)===String(copyData.schoolYearId))?.year??"";
           }
           const journeys = filteReference.current?.getJourneys();
           if(journeys){
                copyData.journey = journeys.find(p=>String(p.journeyId)===String(copyData.journeyId))?.name??"";
           }

           const courses = filteReference.current?.getCursos();
           if(courses){
                copyData.course = courses.find(p=>String(p.courseId)===copyData.courseId)?.name??"";
           }

           const educationLevels = filteReference?.current?.getEducationLeves();
           if (educationLevels.length > 0) {
                copyData.evaluationTypeId = educationLevels.find((c) => String(c.educationLevelId) === String(copyData.educationLevelId))?.evaluationTypeId;
           }

          const evaluationScaleResult = await evaluativeScaleService.getEvaluativeScale(
                copyData.evaluationTypeId,
                copyData.schoolYearId
          );
           setDatosBusqueda(copyData);
           const date = moment(formData.startDate).format("yyyy-MM-DD");
           const prevData = await estudiantesService.getEstudiantesPorCurso(
            "",
            copyData.journeyId,
            copyData.schoolYearId,
            copyData.educationLevelId,
            copyData.courseId
          ); // Obtenemos los estudiantes de tu sistema
          const data = prevData.filter(s=>s.isActive);
          if(data && data.length>0){
            setEstudiantes(data);
          }else{
            toast.error("No se encontraron estudiantes matriculados.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setEstudiantes([]); 
          }
        } catch (error) {
          console.error("Error al obtener asistencias:", error);
        }
        setShowLoading(false);
    }

    const volverLista =  async () => {
        setBoletinInfo(null);
    };

    const generarBoletin =  async (student) => {
        setShowLoading(true);
        const data = await estudiantesService.getEstudianteBoletin(
            student.studentId,
            formData.courseId,
            formData.schoolYearId,
            formData.periodId,
            0
          ); // Obtenemos los estudiantes de tu sistema
          console.log(data);
          setBoletinInfo(data);
          setShowLoading(false);
    };

    

    const columns = [
        { name: "Número", selector: "consecutive", sortable: true, 
        cell: (row, index) => <span>{index + 1}</span>, },      
        { name: "ID", selector: "identification", sortable:true,grow:"2.5",},
        { name: "Nombre completo", selector: "fullName", sortable:true,grow:"6"}, // Asumiendo que 'nombre' contiene tanto el nombre como el apellido
        {
          name: "Acciones",grow:"3",
          selector: "actions",
          cell: (row) => (
            <div className="actions-container justify-content-between align-items-center">
                <button
                    onClick={() => generarBoletin(row)}
                    className="btn-deactivate btn-sm ms-2"
                    title="Exportar">
                    <i class="fa-solid fa-file-pdf"></i>
                </button>
            </div>
          ),
        },
      ];

    const normalizeString = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
    };

    const filteredItems = estudiantes?.filter((item) => {
        if (item) {
          const allData = `${item.fullName} ${item.identification} `;
          const normalizedFilterText = normalizeString(filterText);
          const normalizedItemName = normalizeString(allData);
          return normalizedItemName.includes(normalizedFilterText);
        }
        return item;
      });
    
    const customStyles = useCustomDataTableStyles();


    return (
        <>
          <div className="student-table-container p-3 filter-container">
            <h1>Boletin final</h1>
            <p>Selecciona los filtros para generar el reporte.</p>
            
                <div className="row">
                    <JornadaAnioPeriodoNivelCurso
                                callback={updateForm}
                                ref={filteReference}
                                loadTutoria={true}
                                loadCoordinators={true}
                                hidePeriodo={true}
                                properties={
                                    {
                                        className:'col-md-2 mb-2',
                                        id:'formReport2',
                                        filtro:false
                                    }
                                }
                            />
                        <div className="col-md-2 mb-1 margin-top-45">
                                <Button onClick={generarCosolidadReporteTotal} className="ml-2">Buscar</Button>
                        </div>
                </div>
          </div>
          {showLoading && <Loading />}

          {!showLoading && estudiantes.length>0 && !boletinInfo && (
            <>
             <div className="student-table-container p-3 mt-3">
              <div className="student-table-controls mb-3 d-flex justify-content-between align-items-center">
                <input
                    type="text"
                    placeholder="Buscar estudiante"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    className="form-control form-control-sm w-50"
                />
                </div>
                <DataTable
                title="Lista de estudiantes"
                className="students-datatable shadow-sm rounded"
                columns={columns}
                noDataComponent="No hay información que mostrar, por favor añadela"   
                data={filteredItems}
                pagination
                fixedHeader
                customStyles={customStyles}
                paginationPerPage={50} // Agrega esta propiedad para controlar las filas por página
                paginationRowsPerPageOptions={[50, 100]}

            />
            </div>
            </>
          )}

            {!showLoading && boletinInfo && (
                  <div>
                  <button className="btn btn-secondary"  onClick={()=>{volverLista()}}><i className="fas fa-arrow-left"></i>Volver a lista</button>
                  <RepoBoletin
                    boletin={boletinInfo}
                />
                </div>
            )}

        </>
    );
};
  
export default RepoBoletinFinal;